module.exports = __webpack_public_path__ + "img/bg-trailer.d6cf61a3.jpg";